// SPDX-FileCopyrightText: 2023 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import type { IconProps } from '@tls/treact-ui/icons';
import React from 'react';
import styled from 'styled-components';

const Icon404 = ({ id, width, height, viewBox, ...other }: IconProps) => {
  return (
    <svg
      id={id ?? 'svg-icon-export'}
      width={width ?? '496'}
      height={height ?? '279'}
      viewBox={viewBox ?? '0 0 496 279'}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...other}
    >
      <AlphaMask id='mask0_586_21613' maskUnits='userSpaceOnUse' x='77' y='70' width='342' height='148'>
        <path
          d='M185.355 186.41H168.168V216H138.676V186.41H77.7383V165.414L140.336 73.2266H168.168V162.973H185.355V186.41ZM138.676 162.973V138.754C138.676 136.475 138.708 133.773 138.773 130.648C138.904 127.523 139.034 124.398 139.164 121.273C139.294 118.148 139.424 115.382 139.555 112.973C139.75 110.499 139.88 108.773 139.945 107.797H139.164C137.927 110.466 136.625 113.07 135.258 115.609C133.891 118.083 132.296 120.687 130.473 123.422L104.301 162.973H138.676ZM297.805 144.613C297.805 156.137 296.893 166.423 295.07 175.473C293.312 184.522 290.448 192.204 286.477 198.52C282.57 204.835 277.427 209.652 271.047 212.973C264.667 216.293 256.919 217.953 247.805 217.953C236.346 217.953 226.939 215.056 219.582 209.262C212.225 203.402 206.789 195.004 203.273 184.066C199.758 173.064 198 159.913 198 144.613C198 129.184 199.595 116 202.785 105.062C206.04 94.0599 211.314 85.6289 218.605 79.7695C225.897 73.9102 235.63 70.9805 247.805 70.9805C259.198 70.9805 268.573 73.9102 275.93 79.7695C283.352 85.5638 288.853 93.9622 292.434 104.965C296.014 115.902 297.805 129.118 297.805 144.613ZM227.98 144.613C227.98 155.486 228.566 164.568 229.738 171.859C230.975 179.086 233.026 184.522 235.891 188.168C238.755 191.814 242.727 193.637 247.805 193.637C252.818 193.637 256.757 191.846 259.621 188.266C262.551 184.62 264.634 179.184 265.871 171.957C267.108 164.665 267.727 155.551 267.727 144.613C267.727 133.741 267.108 124.659 265.871 117.367C264.634 110.076 262.551 104.607 259.621 100.961C256.757 97.25 252.818 95.3945 247.805 95.3945C242.727 95.3945 238.755 97.25 235.891 100.961C233.026 104.607 230.975 110.076 229.738 117.367C228.566 124.659 227.98 133.741 227.98 144.613ZM418.262 186.41H401.074V216H371.582V186.41H310.645V165.414L373.242 73.2266L401.074 73.2266V162.973H418.262V186.41ZM371.582 162.973V138.754C371.582 136.475 371.615 133.773 371.68 130.648C371.81 127.523 371.94 124.398 372.07 121.273C372.201 118.148 372.331 115.382 372.461 112.973C372.656 110.499 372.786 108.773 372.852 107.797H372.07C370.833 110.466 369.531 113.07 368.164 115.609C366.797 118.083 365.202 120.687 363.379 123.422L337.207 162.973H371.582Z'
          fill='#285172'
        />
      </AlphaMask>
      <g mask='url(#mask0_586_21613)'>
        <rect width='496' height='279' fill='#285172' />
        <path d='M98 1L400 279H496V0L98 1Z' fill='url(#paint0_linear_586_21613)' />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_586_21613'
          x1='528.436'
          y1='140.168'
          x2='211.524'
          y2='137.766'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' stopOpacity='0.3' />
        </linearGradient>
      </defs>
    </svg>
  );
};

const AlphaMask = styled.mask`
  mask-mode: alpha;
  mask-type: alpha;
`;

export default Icon404;
